<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_OGRN')
      }"
    >
      <input type="hidden" v-model="item.ID" />
      <input
        @change="$parent.removeError(index, 'UF_OGRN')"
        class="i-main-style i-co-executor-style"
        type="text"
        disabled
        v-model="item.UF_OGRN"
      />
      <div class="error-text"></div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_NAME')
      }"
    >
      <input
        @change="$parent.removeError(index, 'UF_NAME')"
        class="i-main-style i-co-executor-style"
        type="text"
        v-model="item.UF_NAME"
        disabled
      />
      <div class="error-text"></div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_PRICE')
      }"
    >
      <input
        @change="$parent.removeError(index, 'UF_PRICE')"
        class="i-main-style i-co-executor-style"
        type="text"
        v-model="item.UF_PRICE"
        :disabled="$parent.$parent.$parent.projectDisabled"
      />
      <div class="error-text"></div>
    </td>
    <td>
      <a
        v-show="!$parent.$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteItem(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
export default {
  props: ["item", "index"],
  name: "system_integrator_list"
};
</script>

<style scoped></style>
